import { message } from 'antd';
import { config } from 'util/config';
import { httpClient } from "util/Api";
import * as globalFunction from 'util/GlobalFunction';

let searchParameter = {};

export function getSectionDataByDefault({ sectionName, parameter, data, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.setState({ defaultFormData: { state: parameter }, state: parameter });
  let componentDefaultValue = { ...sectionComponent.state.componentDefaultValue };
  componentDefaultValue[uie.source] = parameter;
  searchParameter['state'] = parameter;
  sectionComponent.setState({ searchParameter, componentDefaultValue });

  httpClient
    .get('Admin/Lga/GetList?current=1&state=' + parameter)
    .then(({ data }) => {
      if (data.result) {
        pageComponent.setState({ lagData: data.data });
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });

  setTimeout(() => {
    sectionComponent.getSectionDataByDefault();
  }, config.setTimeoutMilliSecond);
}

export function addBySection({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  if (sectionComponent.customForm.current != null) {
    sectionComponent.customForm.current?.additionalFormRef.current?.child.current?.setState({ defaultSelectedRowKeys: [], regionLgaList: [], filteredData: [], data: [] });
  }
  sectionComponent.setState({ showModal: true, componentType: 'Create' });
  setTimeout(() => {
    sectionComponent.customForm.current?.additionalFormRef.current?.child.current?.setState({ defaultSelectedRowKeys: [], regionLgaList: [], filteredData: [], data: [] });
    sectionComponent.customForm.current?.additionalFormRef.current?.child.current?.setState({ filteredData: pageComponent.state.lagData, data: pageComponent.state.lagData });
  }, config.setTimeoutMilliSecond * 10);
}

export function editBySection({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  if (sectionComponent.customForm.current != null) {
    sectionComponent.customForm.current?.additionalFormRef.current?.child.current?.setState({ defaultSelectedRowKeys: [], regionLgaList: [], data: [] });
  }
  sectionComponent.setState({ showModal: true, componentType: 'Edit' });
  setTimeout(() => {
    httpClient
      .get(pageComponent.props.areaName + '/' + sectionName + '/' + parameter.key)
      .then(({ data }) => {
        if (data.result) {
          sectionComponent.customForm.current?.setState({ currentDataKey: data.data.key });

          //把处理后的数据赋值给表单
          sectionComponent.customForm.current?.formRef.current?.setFieldsValue(data.data);
          sectionComponent.customForm.current?.setState({ formData: data.data });

          //获取编辑时的原 regionLga 列表, 设置默认选中项 defaultSelectedRowKeys
          let defaultSelectedRowKeys = [];
          let regionLgaList = [];
          data.data.RegionLgaList.map((regionLga, i) => {
            defaultSelectedRowKeys.push(regionLga.LgaId);
            regionLgaList.push(regionLga);
          });
          let filteredData = pageComponent.state.lagData;
          sectionComponent.customForm.current?.additionalFormRef.current?.child.current?.setState({ defaultSelectedRowKeys: [], regionLgaList: [], filteredData: [], data: [] });
          sectionComponent.customForm.current?.additionalFormRef.current?.child.current?.setState({ selectedRowKeys: defaultSelectedRowKeys, defaultSelectedRowKeys, regionLgaList, filteredData, data: pageComponent.state.lagData });

        } else {
          globalFunction.handleResultError(data, pageComponent);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, pageComponent);
      });
  }, config.setTimeoutMilliSecond);
}

export function showSelectedItemsOnlyOnChange({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  let filteredData = parameter
    ? sectionComponent.customForm.current?.additionalFormRef.current?.child.current?.state.data.filter((item) => sectionComponent.customForm.current?.additionalFormRef.current?.child.current?.state.selectedRowKeys.includes(item.key))
    : sectionComponent.customForm.current?.additionalFormRef.current?.child.current?.state.data;
  sectionComponent.customForm.current?.additionalFormRef.current?.child.current?.setState({ filteredData });
}
